export const PETTY_CASHIER_PANEL = "PETTY_CASHIER_PANEL";
export const MANAGER_PANEL = "MANAGER_PANEL";

export const CUSTODIAN_PANEL = "CUSTODIAN_PANEL";
export const NON_CUSTODIAN_PANEL = " NON_CUSTODIAN_PANEL";